module.exports = __webpack_public_path__ + "media/images/icons/chevron-down-3cb823f8356cabb91b67e73565fb7109.svg";